import CacheBase2 from '../../../services/engines/CacheBase2';

class CsCodeGenConfigCache extends CacheBase2 {
    initialize() {
        this._name = 'CsCodeGenConfigCache';
    }
}

const csCodeGenConfigCache = new CsCodeGenConfigCache();
export default csCodeGenConfigCache;
